import { Icon, IconName, IconVariant } from '../../Graphics';

type SortIconProps = {
  isSorted: boolean;
  isSortedDesc: boolean;
};

export const SortIcon = ({ isSorted, isSortedDesc }: SortIconProps) => {
  if (!isSorted) {
    return (
      <Icon name={IconName.Reorder} variant={IconVariant.TableSortInactive} title="Unsorted column icon" />
    );
  }

  return (
    <Icon
      name={isSortedDesc ? IconName.ChevronDown : IconName.ChevronUp}
      title={isSortedDesc ? 'Icon for column sorted descending' : 'Icon for column sorted ascending'}
      variant={IconVariant.TableSortActive}
      size="0.75em"
    />
  );
};

SortIcon.displayName = 'Table__SortIcon';
